import theme from '@src/theme/theme';
import { RedeemStatus } from '@src/types/bonds/nftRedemption.types';

import { BondsAction } from '@dto/bonds/bonds.dto';

// DOM id of the Mint section; used for hash-scroll (#mint) from EmptyState/Hero.
export const MINT_BONDS_ANCHOR_ID = 'mint';

export const BONDS_REDEEM_DISCOUNT = 0.9;

export const BONDS_REDEEM_DESCRIPTION =
  `Redeem bonds at any time for ${BONDS_REDEEM_DISCOUNT * 100}% of the Bond's value. ` +
  'Select one or multiple bonds at a time. Requests are processed within two business days';

export const BONDS_STAKE_DESCRIPTION =
  'Stake bonds to start earning USDC rewards. You can unstake at any time.';
export const BONDS_UNSTAKE_DESCRIPTION =
  'Unstake to return bonds to your wallet. Rewards stop accruing — you can still redeem matured bonds anytime.';

export const RedeemStatusTitle: Record<RedeemStatus, string> = {
  [RedeemStatus.Pending]: 'Pending',
  [RedeemStatus.Accepted]: 'Accepted',
  [RedeemStatus.Canceled]: 'Canceled',
};

export const RedeemStatusColor = {
  [RedeemStatus.Pending]: theme.palette.custom.tags.processing,
  [RedeemStatus.Accepted]: theme.palette.custom.tags.success,
  [RedeemStatus.Canceled]: theme.palette.custom.tags.reject,
};

export const BondsActionTitle: Record<BondsAction, string> = {
  [BondsAction.Mint]: 'Minted',
  [BondsAction.Transfer]: 'Transferred',
};

export const BondsActionColor = {
  [BondsAction.Mint]: theme.palette.custom.tags.mint,
  [BondsAction.Transfer]: theme.palette.custom.tags.transfer,
};

export const DEBANK_LINK = 'https://debank.com/profile';
// Per client: same docs target as the DexFi Bonds page
export const DOCUMENTATION_LINK =
  'https://sky-dex-bonds.gitbook.io/sky-dex-bonds-docs/';


export const AFFILIATE_ADDRESS = '0xCaEE334CD9353396cC65134f8edE3f3dC4503EDd';
export const AFFILIATE_CODE = 'SKYBONDS';
